/*
 * @author Adrian Nitu <adrian.nitu at gmail.com>
 * @version 0.1 - 2017-05-12
 */

function AjaxPostman(form, successCallback, errorCallback, completeCallback) {

	function init(){
		$(form).on('submit', onSubmit);
	}

	var onSuccess = function (data) {
		$(this).html(data);
	};

	var onError = function (xhr) {
		if (xhr.status == 422) {
			for (var field in xhr.responseJSON) {
				$('*[name=' + field + '], input[name=' + field + ']+label', this)
						.last()
						.after(
								function () {
									$errors = "";
									for (var err in xhr.responseJSON[field])
										$errors += '<span class="help-block">' + xhr.responseJSON[field][err] + '</span>';
									return $errors;
								}
						)
						.parents('.form-group:first').addClass('has-error');
			}
		} else if (xhr.status == 403) {
			console.log(xhr);
		}
	};

	var onComplete = function(xhr) {
		$(this).data('submitting', false).removeClass('submitting');
		$('button[type=submit]',this).button('reset');
	};

	var onSubmit = function(e){
		if(e)
			e.preventDefault();
		if($(this).data('submitting'))
			return false; //double submit

		$('.form-group', this).removeClass('has-error');
		$('.errors').slideUp().removeClass('has-errors');
		$('span.help-block', this).remove();
		$(this).data('submitting', true).addClass('submitting');
		$('button[type=submit]',this).button('loading');

		var ajaxOptions = {
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			cache: false,
			context: this,
	//			dataType: 'json',
			success: successCallback || onSuccess,
			error: errorCallback || onError,
			complete: completeCallback || onComplete
		};

		if($(this).attr('enctype') == "multipart/form-data") {
			ajaxOptions.data = new FormData($(this)[0]);
			ajaxOptions.contentType = false;
			ajaxOptions.processData = false;
		} else {
			ajaxOptions.data = $(this).serialize();
		}
		$.ajax(ajaxOptions);
	};

	init();
}
